<!-- 我的页面 -->
<template>
  <div v-if="showAdd">
    <div class="backmodal">
      <div class="backflex">
        <div class="b_content">
          <div class="box"> 
            <div class="title1" v-if="showAddText">THOM BROWNE 邀请您加入官方会员</div>
            <div class="title2" v-else>
              购买前请开通
              <span class="th">THOM BROWNE</span> 会员
            </div>
            

            <div class="pc">
              <div class="see-list">
                <div class="wrap" v-for="(item, index) in imgData" :key="index">
                  <img class="img" :src="item.src" />
                  <div class="txt">{{ item.txt }}</div>
                </div>
              </div>
            </div>
            <div class="mobile">
              <div class="mobile see-list-mobile">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in imgData"
                      :key="index"
                    >
                      <div class="group">
                        <img class="img" :src="item.src" />
                        <div class="txt">{{ item.text }}</div>
                      </div>
                    </div> 
                  </div>
                    <div class="swiper-pagination"></div>
                </div>
              </div> 
            </div>
            <div class="center_box">
              <div class="term-list ">
                <div class="save">
                  <div class="kuang" @click="term1=!term1">
                    <img class="img" src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="term1" />
                  </div>
                  <div style="flex:1">
                    若勾选本框，您特此同意收集、使用、披露以及对您个人信息的其他处理，包括但不限于用于<span class="term" @click="goPrivacy">隐私政策</span>所述的直接营销之目的。
                  </div>
                </div>
                <div class="save">
                  <div class="kuang" @click="term2=!term2">
                    <img class="img" src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="term2" />
                  </div>
                  <div style="flex:1">
                    若勾选本框，您特此同意<span class="term" @click="goPrivacy">隐私政策</span>所述的您的个人信息在中国境外传输、访问、存储及以其他方式的处理。
                  </div>
                </div>
                <div class="save">
                  <div class="kuang" @click="(term3=!term3)">
                    <img class="img" src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="term3" />
                  </div>
                  <div style="flex:1">
                    若勾选本框，您特此同意收集、使用、披露以及对您个人信息的其他处理 市场和营销（包括通过信件等传统方式以及电子邮件、短信或即时信息等电子方式发送信息、邀请、推广活动材料）。
                  </div>
                </div>
              </div>
              <div class="btn" @click="addNow">立即开通</div>
            </div>
          </div>
          <div class="b_close" @click="close">
            <img src="@/assets/image/icon/close.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Swiper from "swiper";  
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      term1: false,
      term2: false,
      term3: false,
      imgData: [
        {
          src:
            "https://static.getconnectplus.com/origin/202112/4828648b55330988a4d5eb57c0485595.png",
          text: "礼物包装+贺卡",
        },
        {
          src:
            "https://static.getconnectplus.com/origin/202112/e1d1e25beecd8ca89a8a65d6f26e9ae5.png",
          text: "节日问候",
        },
        {
          src:
            "https://static.getconnectplus.com/origin/202112/9ca74ea3b10fa78e684f1d6efdcf19d2.png",
          text: "免费改衣",
        },
        {
          src:
            "https://static.getconnectplus.com/origin/202112/c56b9cc679f01a285df61dece5bfd2b0.png",
          text: "会员加享礼遇",
        },
        {
          src:
            "https://static.getconnectplus.com/origin/202112/ec39113571f265bf6e542b0ec3a97df4.png",
          text: "烫金服务",
        },
      ],
    };
  },
  props: {
    showAddText: {
      type: Boolean,
      default: true
    },
    showAdd: {
      type: Boolean,
      default: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadImg();
     this.swiperDraw();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {
    this.swiperDraw();
  }, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    loadImg(){
      let url = this.$store.state.API.my.crmMemberRightBanner;
      let params = {
      };
      this.$http
        .get(url, params, {
          headers: {
            tb_token: window.localStorage.getItem("token"),
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.data.message == "success" && res.data.result) {
             this.imgData = res.data.returnData;
          }
        });
    },
    goPrivacy(){
      let routeData = this.$router.resolve({
        path: "/privacy",
      });
      window.open(routeData.href, '_blank');
    },
    swiperDraw() {
      var mySwiper = new Swiper(".swiper-container", {
        // slidesPerView: 1,
        // spaceBetween: 30,
        // centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
        },
        paginationClickable :true,
        loop: true,
        navigation: {
          nextEl: ".btn2",
          prevEl: ".btn1",
        },
      });
      this.mySwiper = mySwiper;
    },
    next(){
      this.mySwiper.slideNext();
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    addNow() {
      if (!this.term1) {
        this.$Message.error("请勾选《隐私政策》协议");
        return;
      }
      if (!this.term2) {
        this.$Message.error("请勾选《隐私政策》协议");
        return;
      }
      let url = this.$store.state.API.my.joinCrmMember;
      let params = {
        channel: "ZY",
        identity: this.$store.state.userId,
        mobile: this.$store.state.phoneNumber,
        analysisConsent:0,
        crossBoarder:0,
        allowMarketing:0
      };
      if(this.term1){
        params.analysisConsent = 1;
      }
      if(this.term2){
        params.crossBoarder = 1;
      }
      if(this.term3){
        params.allowMarketing = 1;
      }
      this.$http
        .post(url, params, {
          headers: {
            tb_token: window.localStorage.getItem("token"),
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.data.message == "success" && res.data.result) {
            this.$Message.success("操作成功");
            this.$store.commit("setValue", ["getShowAdd", false]);
            this.$emit("loginCrmSuccess");
          } else {
            this.$Message.error("操作失败");
          }
        });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.pc {
  display: block;
}
.mobile {
  display: none;
}
.backmodal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(104, 104, 104, 0.6);
  z-index: 999;
  .backflex {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .b_content {
      width: 123.2rem;
      padding: 3rem 2rem 2rem;
      background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      .center_box{
        width: 42rem;
        max-width:100%;
        margin:0 auto;
      }
      .box { 
        text-align: center;
        .logo {
          width: 8.6rem;
          height: 3.8rem;
          margin-bottom: 4rem;
        }
        .title1 {
          font-size: 1.4rem;
        }
        .title2 {
          font-size: 1.4rem;
          font-weight: 500;
        }
        .list {
          margin: 2.8rem 0 2.2rem;
          padding: 2rem;
          border: 0.1rem solid #e8e8e8;
          line-height: 1.7rem;
          .title {
            padding-bottom: 0.3rem;
            color: #959595;
          }
          .item {
            display: flex;
            justify-content: center;
            padding: 1rem 2.2rem 0;
            font-weight: 500;
            .middle {
              padding: 0 3rem;
            }
          }
        }
        .see-list {
          display: flex;
          margin-top: 2.6rem;
          border: 1px solid #E8E8E8;
          padding:2.4rem 1.6rem;
          .wrap {
            width: 22.4rem;
            margin-right: 1rem;
            .img {
              width: 100%;
              object-fit: cover;
              height: 28rem;
            }
            .txt {
              text-align: center;
              margin-top: 1.6rem;
              font-size: 1.2rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5c5d5f;
            }
          }
          .wrap:last-child {
            margin-right: 0rem;
          }
        }
        .see-list-mobile {
          margin-top: 2.6rem;
          // overflow: hidden;
          
          .group {
            padding-bottom:4rem;
            .img {
              width: 100%;
              object-fit: cover;
              height: 28rem;
            }
            .txt {
              text-align: center;
              margin-top: 1.6rem;
              font-size: 1.2rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5c5d5f;
            }
          }
        }
        .next {
          width: 100%;
          height: 4rem;
          display:flex;
          justify-content:center;
          align-items:center;
          font-size: 12px;
          font-family: ArialNarrow;
          color: #FFFFFF;
          margin-top:2rem;
          background: #5C5D5F;
        }
        .swiper-container {
          position: relative;
          overflow: hidden;
        }
        .swiper-slide {
          text-align: center;
          transition: 300ms;
          transform: scale(0.8);
          .img_item {
            width: 100%;
            height: 100%;
          }
          .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: #d8d8d8;
            opacity: 0.4;
          }
        }
        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
          .mask {
            display: none;
          }
        }
        .pagination {
          display: flex;
          justify-content: center;
          > img {
            cursor: pointer;
            width: 50px;
            height: 50px;
          }
          .title {
            margin: 0px 5vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 13px;
            font-family: ArialNarrow;
            color: #5c5d5f;
          }
        }
        
        .term-list {
          margin-top:2.2rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .save {
            display: flex;
            // height: 2rem;
            line-height: 2rem;
            align-items: flex-start;
            margin-bottom: 0.5rem;
            text-align: left;
            .kuang{
              position: relative;
              top:0.2rem;
            }
            .term {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        .btn {
          justify-content: center;
          margin-top: 3.2rem;
        }
      }
      .b_close {
        cursor: pointer;
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        top: 3rem;
        right: 2.8rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .backmodal .backflex .b_content {
    width: 34rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 30rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .backmodal .backflex .b_content {
    max-width: 34rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 28rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
   .save{
     align-items:flex-start!important;
   }
}
/deep/.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0.1rem;
}
/deep/.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.5rem;
}
/deep/.swiper-pagination-bullet {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #5C5D5F;
  opacity: 0.3;
}
/deep/.swiper-pagination-bullet-active {
  background-color: #5C5D5F;
  opacity: 1;
  margin: 0 0.5rem;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddMemberPop.vue